import React from 'react';
import { Box } from '@common-fe/common-fe';

import ReceiptsList from './ReceiptsList/ReceiptsList';

const Receipts = () => {
  return (
    <Box data-testId="receipts-tab">
      <ReceiptsList />
    </Box>
  );
};

export default Receipts;
